import '@/csrf';

import React from 'react';
import { createRoot } from 'react-dom/client';
import {Provider} from 'react-redux';
import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import Main from './Main';
import appReducer from './Reducers/reducer';
import {reducer as autoSaveReducer} from '@/AutoSave';

const reducer = combineReducers({
    app: appReducer,
    autoSave: autoSaveReducer,
});

const payload = JSON.parse(document.getElementById('application-data').textContent);

let initialState = {
    app: payload,
    autoSave: {},
};

window.store = createStore(reducer, initialState, applyMiddleware(thunkMiddleware));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={window.store}>
        <Main />
    </Provider>
);
